import React from "react";
import { ProductAvailabilityCode } from "../models/models";
import { Box, Chip, ThemeProvider, createTheme } from "@mui/material";
import moment from "moment";
import useTranslation from '../../../shared/hooks/useTranslation';

export interface StockItemTableAvailabilityProps {
  availabilityCode: ProductAvailabilityCode;
}

const StockItemTableAvailability = ({ availabilityCode }: StockItemTableAvailabilityProps) => {
  const { translate: tInventory } = useTranslation('inventory');

  const getTitle = () => {
    return availabilityCode === ProductAvailabilityCode.inStock
      ? tInventory('inStock')
      : tInventory('out');
  };

  const getColor = () => {
    return availabilityCode === ProductAvailabilityCode.inStock ? "success" : "error";
  };

  const getDeliveryTerm = () => {
    switch (availabilityCode) {
      case ProductAvailabilityCode.inStock:
        return tInventory('shipBy', { date: moment().format('D.M.yyyy') });
      case ProductAvailabilityCode.in7Days:
        return tInventory('readyIn7Days');
      case ProductAvailabilityCode.in14Days:
        return tInventory('readyIn14Days');
      case ProductAvailabilityCode.in1Month:
        return tInventory('readyIn1Month');
      default:
        return '';
    }
  };

  const theme = createTheme({
    components: {
      MuiChip: {
        styleOverrides: {
          root: {
            width: 12,
            height: 5
          },
          colorSuccess: {
            backgroundColor: "#3EA293"
          },
          colorError: {
            backgroundColor: "#F23E3E"
          }
        }
      }
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Box className="text-14-medium" sx={{ color: "#333" }}>
          {getTitle()}
          <Chip className="ms-2" color={getColor()} />
        </Box>
        <Box className="text-12-medium">{getDeliveryTerm()}</Box>
      </Box>
    </ThemeProvider>
  );
};

export default StockItemTableAvailability;